import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, useBreakpointValue } from '@chakra-ui/react';
/**
 * using css instead of JS, avoid the UI flickering
 */
export const InMobile = ({ children }) => {
    return (_jsx(Box, { display: {
            // using `contents` to ignore this <Box>'s layout
            base: 'contents',
            desktop: 'none',
        }, children: children }));
};
/**
 * using css instead of JS, avoid the UI flickering
 */
export const InDesktop = ({ children }) => {
    return (_jsx(Box, { display: {
            base: 'none',
            // using `contents` to ignore this <Box>'s layout
            desktop: 'contents',
        }, children: children }));
};
/**
 * using <RenderInMobile /> only if it won't cause UI flickering
 */
export const RenderInMobile = ({ children }) => {
    return _jsx(_Fragment, { children: useIsDesktop() === false ? children : undefined });
};
/**
 * using <RenderInDesktop /> only if it won't cause UI flickering
 */
export const RenderInDesktop = ({ children }) => {
    return _jsx(_Fragment, { children: useIsDesktop() === true ? children : undefined });
};
export const useIsDesktop = () => {
    return useBreakpointValue({
        base: false,
        desktop: true,
    }, {
        ssr: typeof window === 'undefined',
    });
};
